import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useSiteContent } from '../../context/SiteContentContext';

const CTABottom = () => {
  const { siteContent } = useSiteContent();
  const finalCta = siteContent?.finalCta || {};

  if (finalCta.visible === false) return null;

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-slate-900">
      <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-white mb-3 sm:mb-4">
            {finalCta.title || 'Ready to Start?'}
          </h2>
          <p className="text-base sm:text-lg text-slate-400 mb-8 sm:mb-10">
            {finalCta.subtitle || 'Book your free trial lesson today.'}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center bg-white text-slate-900 hover:bg-slate-100 rounded-full px-7 sm:px-8 py-4 text-base font-medium transition-all"
            >
              {finalCta.ctaPrimary || 'Contact Us'}
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
            <Link
              to="/programs"
              className="inline-flex items-center justify-center bg-transparent text-white border border-slate-700 hover:border-slate-500 hover:bg-slate-800 rounded-full px-7 sm:px-8 py-4 text-base font-medium transition-all"
            >
              {finalCta.ctaSecondary || 'View Program'}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABottom;
